import { render, staticRenderFns } from "./SYSecret.vue?vue&type=template&id=324628ac&"
import script from "./SYSecret.vue?vue&type=script&lang=js&"
export * from "./SYSecret.vue?vue&type=script&lang=js&"
import style0 from "./SYSecret.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports